import { getStore } from 'mini-mail-search-store/lib/store/Store';

/**
 * Returns selected folderId for search
 */
export default function getCurrentSelectedFolderId(): string {
    return getStore().staticFolderScopeId;
}
